import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import { IconButton, Tooltip, Typography } from '@mui/material';
// components
import Chart, { useChart } from '../../../components/chart';
import Iconify from '../../../components/iconify';
import ClickableTooltip from '../../../components/tooltip/clickable-tooltip';

// ----------------------------------------------------------------------

export default function ChartProfileSingleDeactivated({ title, chart, color, icon, tooltip, ...other }) {
  const theme = useTheme();

  const { series, options } = chart;

  const chartOptions = useChart({
    chart: {
      offsetY: -16,
      sparkline: {
        enabled: true,
      },
    },
    grid: {
      padding: {
        top: 24,
        bottom: 24,
      },
    },
    legend: {
      show: false,
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        hollow: {
          size: '56%',
        },
        dataLabels: {
          name: {
            offsetY: 8,
            show: false,
          },
          value: {
            offsetY: -20,
            show: false,
          },
        },
      },
    },
    fill: {
      type: 'solid',
      colors: [color],
    },
    ...options,
  });

  return (
    <Card {...other} sx={{ flex: 1, p: 3, textAlign: 'center' }}>
      <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" sx={{ mb: 2 }}>
        {icon && (
          <Iconify icon={icon} width={40} height={40} />
        )}
        <Typography variant="h5">
          {title}
        </Typography>
        {tooltip && (
          <ClickableTooltip title={tooltip} arrow>
            <IconButton component="span" sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <Iconify icon="mdi:information-outline" width={18} height={18} color={theme.palette.text.secondary} />
            </IconButton>
          </ClickableTooltip>
        )}
      </Stack>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Chart
          type="radialBar"
          series={[series]}
          options={chartOptions}
          height={360}
        />
      </Box>
    </Card>
  );
}

ChartProfileSingleDeactivated.propTypes = {
  title: PropTypes.string,
  chart: PropTypes.object,
  color: PropTypes.string,
  icon: PropTypes.string,
  tooltip: PropTypes.string,
};
